import { render, staticRenderFns } from "./SituationBadges.vue?vue&type=template&id=380c99b2&"
import script from "./SituationBadges.vue?vue&type=script&lang=js&"
export * from "./SituationBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports